import { createSelector } from 'reselect';

import { BonusStatus } from '@ezugi/constants';

import { RootState } from '../..';
import { tableIdSelector } from './table';
import { currencySelector, userOperatorIdSelector } from './user';

export const bonusSelectedChipSelector = (state: RootState) => state.bonus.selectedChip;
export const bonusStatusSelector = (state: RootState) => state.bonus.status;
export const shouldRenderBonusSelector = createSelector(
  bonusStatusSelector,
  (bonusStatus) => bonusStatus !== BonusStatus.WaitingForTrigger
);
export const bonusMultiplierPrizeSelector = (state: RootState) => state.bonus.multiplierPrize;
export const bonusWonAmountSelector = (state: RootState) => state.bonus.wonAmount;
export const bonusTimeLeftSelector = (state: RootState) => state.bonus.timers.timeLeft;
export const bonusDurationSelector = (state: RootState) => state.bonus.timers.duration;
export const isBonusRejectedSelector = (state: RootState) => state.bonus.rejected;
export const isBonusVisibleSelector = (state: RootState) => state.bonus.visible;
export const wasStreamSoundMutedBeforeBonusSelector = (state: RootState) => state.bonus.wasStreamSoundMutedBeforeBonus;
export const bonusHasOperatorErrorSelector = (state: RootState) => state.bonus.hasOperatorError || false;
export const bonusChipsSelector = (state: RootState) => state.bonus.chips;
export const bonusRoundIdSelector = (state: RootState) => state.bonus.roundId;
export const bonusWheelConfigSelector = (state: RootState) => state.config.bonus?.bonusWheelConfig;
export const bonusCurrencyThresholdSelector = createSelector(
  bonusWheelConfigSelector,
  currencySelector,
  (config, currency) => config?.currencyThresholds[currency ?? ''] ?? 0
);
export const isBonusWheelActiveOnTableSelector = createSelector(
  bonusWheelConfigSelector,
  tableIdSelector,
  userOperatorIdSelector,
  (bonusWheelConfig, tableId, operatorId) => Boolean(bonusWheelConfig?.enabled
  && bonusWheelConfig.tableIds.includes(tableId)
  && bonusWheelConfig.operatorIds.includes(Number(operatorId)))
);
export const bonusMaxTutorialDisplaysSelector = createSelector(
  bonusWheelConfigSelector,
  (config) => config?.maxTutorialDisplays
);
